// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ImgResponsive":"bbx_a bhr_a bhr_q bhr_j bhr_wl bhr_bj","ImgResponsive__img":"bbx_b bhr_b bhr_ql"};